import Spinner from "../components/Spinner"
import Div from "../components/Div"
import FormButton from "../components/FormButton"
import PageTitle from "../components/PageTitle"
import { CiImport } from "react-icons/ci";
import { checkDomain, checkDomainFile } from "../http/DomianCheckerHttp"
import { useState, useRef } from "react"


export default function DomainChecker() {

    const [search, setSearch] = useState('')
    const [domainList, setDomainList] = useState(false)
    const [file, setFile] = useState(false)
    const [isLoader, setIsLoading] = useState(false)
    const fileInputRef = useRef(null);

    async function handleSearch() {
        setIsLoading(true)
        if (search) {
            console.log(search);
            const response = await checkDomain(search)
            console.log(response.message);
            setDomainList(response.message)
            setIsLoading(false)
        }
        else if (file) {
            const response = await checkDomainFile(file)
            if (!response) {
                alert('There is an issue with the file. Please try again...!')
                setIsLoading(false)
                return
            }
            console.log(response);
            // setDomainList(response.message)
            setIsLoading(false)
        }
        else {
            alert('Enter a domain or upload a file')
            setIsLoading(false)
        }

    }

    function handleExport() {
        if (domainList) {
            const title = ["Domain"]; // CSV header
            const array = domainList.domain; // Assuming domainList.domain is an array of domains

            // Combine the header and data rows
            const rows = [title, ...array.map((domain) => [domain])];

            // Convert rows to CSV string
            const csvContent = rows
                .map((row) => row.join(",")) // Join each row with commas
                .join("\n"); // Join rows with newlines
            console.log(csvContent)
            // Create and download the blob
            const blob = new Blob([csvContent], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = "export_data.csv";
            document.body.appendChild(a); // Required for some browsers
            a.click();
            document.body.removeChild(a); // Clean up
            window.URL.revokeObjectURL(url); // Free memory
        } else {
            console.warn("domainList is empty or undefined."); // Added logging for debug
        }
    }


    const downloadTemplate = () => {
        const header = ["Domain"]; // CSV header
        const domains = ["abc.com", "xyz.com", "pqr.com"]; // Data rows
        const rows = [header, ...domains.map((domain) => [domain])];

        // Convert rows to CSV string
        const csvContent = rows
            .map((row) => row.join(",")) // Join each row with commas
            .join("\n"); // Join rows with newlines

        // Create and download the blob
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "template.csv";
        document.body.appendChild(a); // Required for some browsers
        a.click();
        document.body.removeChild(a); // Clean up
        window.URL.revokeObjectURL(url); // Free memory
    }

    function onSearchChange(event) {
        setSearch(event.target.value)

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    function onFileChange(event) {
        setFile(event.target.files[0])
        setSearch('')
    }


    return <>
        <PageTitle title='Domain Checker' />
        {isLoader ? <Spinner /> : null}

        <Div className="btn-group toolbar-item" role="group" style={{ marginLeft: '15px' }}>
            <input type="text" name="domain" onChange={onSearchChange}
                value={search} id="domain" className="" style={{ margin: '5px' }} />
            <input type="file" name="file" id="domain" className=""
                style={{ margin: '5px' }} onChange={onFileChange} />
        </Div>
        <FormButton type="button"
            onClick={handleSearch} style={{ margin: '5px' }}
            className="btn btn-primary toolbar-item">Check Domain</FormButton>

        <FormButton
            className="btn btn-primary ml-2"
            style={{ float: "right" }}
            onClick={downloadTemplate}
        // title="Export Template"
        >
            Template
        </FormButton>

        <FormButton
            className="btn btn-primary ml-2"
            style={{ float: "right" }}
            onClick={handleExport}
            title="Export Data"
        >
            <CiImport size={15} />
        </FormButton>

        <Div className='row-cols-1'>
            <Div className="table-responsive" style={{ marginTop: '7%', marginLeft: '10px' }}>
                {domainList ?
                    <table style={{ border: '1px solid black', width: '100%' }}>
                        <thead>
                            <tr>
                                <th>Domain Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {domainList.domain.map((domains, index) => (
                                <tr key={index} style={{ border: '1px solid black' }}>
                                    <td>{domains}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table> : ''

                }

            </Div>

        </Div>
    </>
}